import { branch, compose, renderNothing, withProps } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { selectUserData, selectRouteKey } from 'src/store/selectors/layout'
import { selectCustomerProfile } from 'src/store/selectors/customerProfile'
import { selectHomeData } from 'src/store/selectors/home'
import { hasCustomerToken } from 'src/auth'

const web = process.env.REACT_APP_WEB_URL
const mainstreet = process.env.REACT_APP_MAIN_STREET_URI

const AgentNavigationContainer = compose(
  connect(state => ({
    customerProfile: selectCustomerProfile(state) || {},
    home: selectHomeData(state),
    userData: selectUserData(state)
  })),
  withRouter,
  withProps(({ customerProfile, home, userData }) => {
    const routeKey = selectRouteKey()

    if (home && routeKey === 'home') {
      if (!customerProfile.legacyRef) {
        return { routeKey }
      }

      return {
        routeKey,
        backLink: `${web}/admin/agent/${
          customerProfile.legacyRef
        }/home-detail/${home.id}`
      }
    }

    if (userData && routeKey === 'buy') {
      return {
        routeKey,
        backLink: `${mainstreet}/buyers/${userData.id}`
      }
    }
  }),
  branch(
    ({ routeKey }) =>
      !hasCustomerToken() || !['home', 'buy'].includes(routeKey),
    renderNothing
  )
)

export default AgentNavigationContainer
